import React, { useState } from "react";

const Faq = (value) => {
  const [selectedQuestion, setSelectedQuestion] = useState("q_1"); 
  console.log(selectedQuestion);
  function onClickSubSelectedQuestion(element){
    console.log(element);
    // selectedQuestion !== ""? 
  }

  return (
    <div>
      <div className="d-flex justify-content-center">
        <div>
          <div>
            <div
              className="faq_question"
              id="q_1"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_1" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_1" ? "-" : "+"} </span> How do I
              navigate the survey report?{" "}
            </div>
            {selectedQuestion === "q_1" ? (
              <div className="faq_contents">
                You are now in LogRatio’s Dashboard.
                <br />
                Each button on the top of this page opens a section where you
                can read and interact with a selection of the analyses LogRatio
                conducted on your survey data.
                <br />
                Read the{" "}
                <a
                  href="#!"
                  onClick={
                    () => window.parent.postMessage({
                      cmd: "hyperlink",
                      url: "https://logratio.com/users-guide/"
                    }, "https://logratio.com")
                  }
                >
                  Help
                </a>{" "}
                file for more details about the individual analyses.
                <br />
                Use the Download button to access the complete version of your
                survey report, which includes an Excel and a PDF file. Read also
                the answer to the question “How to download this report”.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_2"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_2" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_2" ? "-" : "+"} </span> How do I
              return to the survey report?{" "}
            </div>
            {selectedQuestion === "q_2" ? (
              <div className="faq_contents">
                From the LogRatio Menu select <a
                  href="#!"
                  onClick={
                    () => window.parent.postMessage({
                      cmd: "hyperlink",
                      url: "https://logratio.com/account/lg_project_list/"
                    }, "https://logratio.com")
                  }
                >Account → Project</a>{" "}
                List and click on the relevant Dashboard link.
                <br />
                <div className="d-flex justify-content-center mt-3">
                  <img src="./images/Picture.png" width="500" />
                </div>
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_3"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_3" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_3" ? "-" : "+"} </span> How do I
              download the survey report?{" "}
            </div>
            {selectedQuestion === "q_3" ? (
              <div className="faq_contents">
                There are two ways: from the online Dashboard and from the User
                Account.
                <br />
                To access the reports from the <strong>online Dashboard</strong>
                , click on the Download button and select either the Excel or
                the PDF report.
                <br />
                The former file contains the numbers and the latter one contains
                the verbal interpretation of the numbers.
                <div className="d-flex justify-content-center mt-3 mb-3">
                  <img src="./images/Picture-3.png" width="600" />
                </div>
                To access the reports from the <strong>User Account</strong>,
                select Account from the Menu and then go to the Project List
                page.
                <div className="d-flex justify-content-center mt-3">
                  <img src="./images/Picture-1.png" width="150" />
                </div>
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_4"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_4" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_4" ? "-" : "+"} </span> Is there a
              Help file for LogRatio?{" "}
            </div>
            {selectedQuestion === "q_4" ? (
              <div className="faq_contents">
                Yes, select Help from the LogRatio Menu or{" "}
                <a href="#!" onClick={
                  () => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/users-guide/"
                  }, "https://logratio.com")
                }>
                  click here.
                </a>
                <div className="d-flex justify-content-center mt-3">
                  <img src="./images/Picture-2.png" width="150" />
                </div>
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_5"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_5" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_5" ? "-" : "+"} </span> How do I
              prepare my survey data for LogRatio?{" "}
            </div>
            {selectedQuestion === "q_5" ? (
              <div className="faq_contents">
                Read chapter{" "}
                <a
                  href="#!"
                  onClick={
                    () => window.parent.postMessage({
                      cmd: "hyperlink",
                      url: "https://logratio.com/users-guide/#survey-data-how-to-format-your-input-file"
                    }, "https://logratio.com")
                  }
                >
                  {" "}
                  3.1.Survey data: How to format your input file{" "}
                </a>{" "}
                in the LogRatio Help and watch the video.
                <br />
                If it doesn’t help,{" "}
                <a href="#!" onClick={
                  () => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/contact/"
                  }, "https://logratio.com")
                }>
                  contact us
                </a>
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_7"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_7" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_7" ? "-" : "+"} </span> Can I
              partner with the LogRatio project?{" "}
            </div>
            {selectedQuestion === "q_7" ? (
              <div className="faq_contents">
                Thank you for asking.
                <br />
                At this stage the LogRatio project needs resources and
                commitment.
                <br />
                <strong>Resources</strong> like financial investments,
                donations, and programming ability are all very welcome. We have
                an ambitious development program in place, and your contribution
                with one or more of the resources we need will be greatly
                appreciated.
                <br />
                The <strong>commitment</strong> of writers and promoters would
                also be of great help to the LogRatio project. The LogRatio blog
                needs quality content, in the form of articles, reports,
                explanations, and the like, and informing instructors and
                students about what LogRatio can do for them are all very
                important ways to support LogRatio.
                <a href="#!" onClick={
                  () => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/contact/"
                  }, "https://logratio.com")
                }>
                  Contact us
                </a>{" "}
                if you can help LogRatio.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_8"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_8" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_8" ? "-" : "+"} </span> I am an
              investor interested in the LogRatio project{" "}
            </div>
            {selectedQuestion === "q_8" ? (
              <div className="faq_contents">
                <a href="#!" onClick={() => window.parent.postMessage({
                  cmd: "hyperlink",
                  url: "https://logratio.com/contact/"
                }, "https://logratio.com")}>
                  Contact us
                </a>{" "}
                and let’s talk.
                <br />
                LogRatio needs funds for a number of activities and we are ready
                to trade company shares for financial support.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_6"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_6" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_6" ? "-" : "+"} </span> How can I
              make a donation to the LogRatio project?{" "}
            </div>
            {selectedQuestion === "q_6" ? (
              <div className="faq_contents">
                Thank you asking this.
                <br />
                Please{" "}
                <a href="#!" onClick={() => window.parent.postMessage({
                  cmd: "hyperlink",
                  url: "https://logratio.com/donate/"
                }, "https://logratio.com")}>
                  click here to donate
                </a>{" "}
                to the LogRatio project.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_9"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_9" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_9" ? "-" : "+"} </span> Can I
              publish a post on the LogRatio blog?{" "}
            </div>
            {selectedQuestion === "q_9" ? (
              <div className="faq_contents">
                Sure.{" "}
                <a href="#!" onClick={() => window.parent.postMessage({
                  cmd: "hyperlink",
                  url: "https://logratio.com/contact/"
                }, "https://logratio.com")}>
                  contact us
                </a>{" "}
                and explain in detail what you’d like to post on the LogRatio
                blog space.
                <br />
                We appreciate quality content relating to marketing research,
                including research results, research papers, explanation of
                basic concepts, trends, innovations, and other topics relevant
                to marketing research.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_11"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_11" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_11" ? "-" : "+"} </span> Can I use
              LogRatio with my students?{" "}
            </div>
            {selectedQuestion === "q_11" ? (
              <div className="faq_contents">
                Sure. Please feel free to use LogRatio in your lessons.
                <br />
                We’d appreciate if you let us know how your students use
                LogRatio, and we‘d also appreciate if you and your students
                could mention LogRatio on socials.
                <br />
                We require only that the LogRatio branding elements not be
                modified, and you must clearly state that the material you use
                comes from the LogRatio site.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_12"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_12" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_12" ? "-" : "+"} </span> Can we
              make LogRatio available to our clients?{" "}
            </div>
            {selectedQuestion === "q_12" ? (
              <div className="faq_contents">
                <a href="#!" onClick={() => window.parent.postMessage({
                  cmd: "hyperlink",
                  url: "https://logratio.com/contact/"
                }, "https://logratio.com")}>
                  Contact us
                </a>
                . At this stage we are open to cooperating with Online Survey
                Providers and others who work with survey users.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_10"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_10" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_10" ? "-" : "+"} </span> Can I use
              LogRatio for my lessons?{" "}
            </div>
            {selectedQuestion === "q_10" ? (
              <div className="faq_contents">
                Sure, please, feel free to use LogRatio in your lessons. We’d
                appreciate if you let us know how your students like LogRatio,
                and we‘d also appreciate if you could mention LogRatio on
                socials.
                <hr />
              </div>
            ) : null}
          </div>
          <div>
            <div
              className="faq_question"
              id="q_13"
              onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}
            >
              {" "}
              <span id="q_13" onClick={(e) => setSelectedQuestion(selectedQuestion !== e.target.id? e.target.id: "")}>{selectedQuestion === "q_13" ? "-" : "+"} </span> Can we put
              our brand on the LogRatio report?{" "}
            </div>
            {selectedQuestion === "q_13" ? (
              <div className="faq_contents">
                No, this is not an option.
                <hr />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div >
  );
};

export default Faq;
